
// material-ui
import { Stack } from '@mui/material';

// project import
import RecentZipCodesTable from './RecentZipCodesTable';

// assets
import { Notice } from 'components/Notice';
import { isShopifyApp } from 'context/UserAuthContext';
import { Link } from 'react-router-dom';
import { RecentlyViewedProductEstimatedDates } from './RecentlyViewedProductEstimatedDates';



// ==============================|| DASHBOARD - DEFAULT ||============================== //

const DashboardDefault = () => {
    return <DashboardUser />
}

const DashboardUser = () => {
    const gettingStartedClosed = localStorage.getItem('getting-started-closed') || false;
    return <>
        <Stack spacing={4} direction="column">
            {!gettingStartedClosed && (
                <Notice id="getting-started" title="Getting Started" onClose={()=>{
                    localStorage.setItem('getting-started-closed', true);
                }}>
                    <p>
                        To get started, follow the following steps:
                    </p>
                    <ol>
                        <li>Go over to the <Link to="/carriers">carriers</Link> page and add 1 or more delivery carriers that service your warehouse(s)</li>
                        <li>Next, go to the <Link to="/warehouses">warehouse</Link> page and make sure you have at least 1 warehouse added with an accurate address. This information is used to calculate delivery dates. Click on a warehouse to edit and assign your carriers to each warehouse.</li>
                        <li>Now, head over to the <Link to="/credentials">credentials</Link> page and generate an api key. Copy the API Key to be used in your integration.</li>
                        {isShopifyApp() ? (
                            <li>If integrating with a Shopify theme 2.0, using the shopify navigation to the left, choose <strong>Online Store</strong> -&gt; <strong>Themes</strong> -&gt;<strong>Customize</strong> to customize your theme. On the Product Template for your theme, choose <strong>Add Block</strong>. Select the "Estimated Delivery" block and drag it to be just above the "Buy buttons" block or wherever your design allows. Now, select the "Estimated Delivery" block to customize the settings. Be sure to paste the copied API Key within the settings and Save.</li>
                        ) : <></>}
                        <li>Optionally, on the <Link to="/holidays">holidays</Link> page, set any upcoming observed holidays that you would like displayed.</li>
                        <li>Thats it! If your integration is correct, Product, Order, and Tracking information should populate automatically over time.</li>
                    </ol> 
                    <p>
                        For more information, view our <a href={process.env.REACT_APP_DOCS_URL} target="_blank">documentation</a> to get started.
                    </p>
                </Notice>
            )}
            <RecentZipCodesTable />
            <RecentlyViewedProductEstimatedDates />
        </Stack>
    </>;
}


export default DashboardDefault;
